export const leadStatusConstants = {
  LEAD_STATUS_CREATE_LOADING: 'LEAD_STATUS_CREATE_LOADING',
  LEAD_STATUS_CREATE_SUCCESS: 'LEAD_STATUS_CREATE_SUCCESS',
  LEAD_STATUS_CREATE_FAILURE: 'LEAD_STATUS_CREATE_FAILURE',
  LEAD_STATUS_ERROR_RELOAD: 'LEAD_STATUS_ERROR_RELOAD',

  LEAD_STATUS_LIST_LOADING: 'LEAD_STATUS_LIST_LOADING',
  LEAD_STATUS_LIST_SUCCESS: 'LEAD_STATUS_LIST_SUCCESS',
  LEAD_STATUS_LIST_FAILURE: 'LEAD_STATUS_LIST_FAILURE',

  LEAD_STATUS_EDIT_LOADING: 'LEAD_STATUS_EDIT_LOADING',
  LEAD_STATUS_EDIT_SUCCESS: 'LEAD_STATUS_EDIT_SUCCESS',
  LEAD_STATUS_EDIT_FAILURE: 'LEAD_STATUS_EDIT_FAILURE',

  LEAD_STATUS_DELETE_LOADING: 'LEAD_STATUS_DELETE_LOADING',
  LEAD_STATUS_DELETE_SUCCESS: 'LEAD_STATUS_DELETE_SUCCESS',
  LEAD_STATUS_DELETE_FAILURE: 'LEAD_STATUS_DELETE_FAILURE'
};
